










































































    import { Component } from 'vue-property-decorator';
    import { Base } from '../common/base';
    import {
        VoiceCallModel, CallType,
    } from '@/models/fixedops/repairorder';
    import { PartSaleCustomerModel } from '@/models/fixedops/partsales';
    import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
    import {voiceCallService,callTypeService,customerService} from '@/shared';

    @Component({
        watch: {
            customerInformation(newVal, oldVal) {
                this.getCustomerInfo(newVal);
            },
        },
        props: ['customerInformation'],
    })
    export default class PartSaleVoiceConversationComponent extends Base {
        public customerInfo: PartSaleCustomerModel = new PartSaleCustomerModel();
        public callTypes: CallType[] = [];
        public isLoaded: boolean = false;
        public isCallTypeLoaded: boolean = false;
        public isCustomerInfoLoading: boolean = false;
        public ismakeCallLoading: boolean = false;

        public mounted(): void {
            this.getCallTypes();
        }

        public close(): void {
            this.$emit('onClose');
        }

        public async getCallTypes(): Promise<void> {
            try {
                this.isCallTypeLoaded = true;
                const response = await callTypeService.getCallTypesAsync();
                this.callTypes = response.results;
            } finally {
                this.isCallTypeLoaded = false;
            }
        }

        public async makeCall(): Promise<void> {
            try {
                this.ismakeCallLoading = true;
                const voiceCallModel: VoiceCallModel = {
                    callType: this.customerInfo.callType,
                    customerKey: this.customerInfo.customerKey,
                    customerName: this.customerInfo.customerName,
                    recordIdentifier: MetadataType[MetadataType.PartSales],
                    recordKey: this.customerInfo.invoiceNumber,
                    recordKeyIdentifier: MetadataKeyIdentifier[MetadataKeyIdentifier.InvoiceNumber],
                    toNumber: this.customerPhoneNumber(),
                };

                if (!voiceCallModel.toNumber || voiceCallModel.toNumber === '0') {
                    this.showAlert(false, this.$t('partSalesVoiceConversation.alertcustomerPhoneCanNotEmpty'));
                    return;
                }

                const response = await voiceCallService.makeOutboundCallAsync(voiceCallModel);
                if (response.isSuccess) {
                    this.showAlert(true, response.message);
                } else {
                    this.showAlert(false, this.$t('partSalesVoiceConversation.alertSomeErrorOccurredWhileMakingCall'));
                }
                this.close();
            } finally {
                this.ismakeCallLoading = false;
            }
        }

        public customerPhoneNumber(): string {
            let pNumber = '';
            switch (this.customerInfo.callTo) {
                case 'home': {
                    pNumber = this.customerInfo.customerPhoneNumber;
                    break;
                }
                case 'cellphone': {
                    pNumber = this.customerInfo.cellPhone;
                    break;
                }
                case 'businessPhone': {
                    pNumber = this.customerInfo.businessPhone;
                    break;
                }
                case 'other': {
                    pNumber = this.customerInfo.otherNumber;
                    break;
                }
                default: {
                    pNumber = this.customerInfo.customerPhoneNumber;
                }
            }
            return pNumber;
        }


public allowOnlyNumbers(event: KeyboardEvent): void {
  const key = event.key;

  // allow control keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Tab'
  ) {
    return;
  }

  // allow only digits
  if (!/^\d$/.test(key)) {
    event.preventDefault();
  }
}

public onPasteOnlyNumbers(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData('text') || '';
  const digitsOnly = pastedText.replace(/\D/g, '');

  this.customerInfo.otherNumber = digitsOnly;
}


        public async getCustomerInfo(
            model: PartSaleCustomerModel,
        ): Promise<void> {
            try {
                this.isCustomerInfoLoading = true;
                this.isLoaded = false;
                const response = await customerService.getCustomerInfoAsync(
                    model.customerKey,
                );

                this.customerInfo.customerKey = response.customerKey;
                this.customerInfo.invoiceNumber = model.invoiceNumber;
                this.customerInfo.cellPhone = response.cellPhone;
                this.customerInfo.customerName = response.customerName;
                this.customerInfo.customerPhoneNumber = response.phoneNumber;

                if (this.callTypes && this.callTypes.length > 0) {
                    this.customerInfo.callType = String(this.callTypes[0].id);
                }

                this.customerInfo.callTo = 'home';
                this.customerInfo.otherNumber = '';
                this.isLoaded = true;
            } catch (e) {
                this.close();
            } finally {
                this.isCustomerInfoLoading = false;
            }
        }
    }
